import {
  Radio as RACRadio,
  RadioGroup as RACRadioGroup,
  type RadioGroupProps as RACRadioGroupProps,
  type RadioProps as RACRadioProps,
} from "react-aria-components";

export interface RadioGroupProps extends RACRadioGroupProps {}
export interface RadioProps extends RACRadioProps {}

export function RadioGroup(props: RadioGroupProps) {
  return <RACRadioGroup {...props} />;
}

export function Radio(props: RadioProps) {
  return <RACRadio {...props} />;
}
